var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { "body-style": { padding: "0" } } },
        [
          _c(
            "el-form",
            {
              ref: "formState",
              attrs: {
                "label-width": "110px",
                model: _vm.formState,
                inline: true,
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { staticClass: "flex-1", attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { clearable: "", placeholder: "请输入活动名称" },
                    model: {
                      value: _vm.formState.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "name", $$v)
                      },
                      expression: "formState.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      on: { change: _vm.topTypeChange },
                      model: {
                        value: _vm.formState.state,
                        callback: function ($$v) {
                          _vm.$set(_vm.formState, "state", $$v)
                        },
                        expression: "formState.state",
                      },
                    },
                    _vm._l(_vm.stateList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "flex-1", attrs: { label: "开始时间：" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetime",
                      placeholder: "选择日期",
                    },
                    model: {
                      value: _vm.formState.startTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "startTime", $$v)
                      },
                      expression: "formState.startTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "flex-1", attrs: { label: "创建人：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { clearable: "", placeholder: "请输入姓名或手机号" },
                    model: {
                      value: _vm.formState.createUserInfo,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "createUserInfo", $$v)
                      },
                      expression: "formState.createUserInfo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "隶属公司", prop: "merchantId" } },
                [
                  _c("YdMerchantSelector", {
                    attrs: { placeholder: "请选择隶属公司" },
                    on: { change: _vm.onChange },
                    model: {
                      value: _vm.formState.merchantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "merchantId", $$v)
                      },
                      expression: "formState.merchantId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "线路", prop: "lineId" } },
                [
                  _c("YdLineSelector", {
                    attrs: {
                      disabled: !_vm.formState.merchantId,
                      placeholder: "请选择活动路线",
                      merchantId: _vm.formState.merchantId,
                    },
                    model: {
                      value: _vm.formState.lineId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "lineId", $$v)
                      },
                      expression: "formState.lineId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.onSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        size: "mini",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onClear("formState")
                        },
                      },
                    },
                    [_vm._v("清除")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["order_reduce_add"],
                          expression: "['order_reduce_add']",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.add },
                    },
                    [_vm._v("新建活动")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "margin-top-10",
          attrs: { "body-style": { padding: "0" } },
        },
        [
          _c(
            "yd-table",
            {
              ref: "agentTable",
              attrs: {
                loading: _vm.loading,
                data: _vm.list,
                border: "",
                "highlight-current-row": "",
                "max-height": "680",
                pagination: _vm.pagination,
              },
              on: { onChange: _vm.onTableChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "left",
                  align: "left",
                  prop: "name",
                  label: "活动名称",
                  width: "150",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handle(scope.row, "detail")
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.name))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠类型",
                  prop: "tiaoJianStr",
                  width: "120",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠",
                  width: "160",
                  prop: "youhui",
                  "show-overflow-tooltip": true,
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  label: "隶属公司",
                  prop: "merchantNames",
                  "show-overflow-tooltip": true,
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  label: "线路",
                  prop: "lineNames",
                  "show-overflow-tooltip": true,
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "180",
                  label: "开始时间",
                  prop: "startTime",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "180",
                  label: "结束时间",
                  prop: "endTime",
                  "show-overflow-tooltip": true,
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  width: "120",
                  prop: "createUserName",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  width: "180",
                  prop: "createTime",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "状态",
                  width: "120",
                  prop: "stateStr",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  width: "180",
                  label: "操作",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value:
                                  _vm.handleLoading &&
                                  scope.row.id === _vm.now.id,
                                expression:
                                  "handleLoading && scope.row.id === now.id",
                              },
                            ],
                            staticClass: "flex-center",
                          },
                          [
                            [1, 2, 3, 5].includes(scope.row.state)
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["order_reduce_edit"],
                                        expression: "['order_reduce_edit']",
                                      },
                                    ],
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handle(scope.row, "edit")
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            scope.row.state === 1
                              ? _c(
                                  "el-popconfirm",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["order_reduce_pass"],
                                        expression: "['order_reduce_pass']",
                                      },
                                    ],
                                    attrs: { title: "确定通过吗？" },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.handle(scope.row, 1)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "margin-left-5",
                                        attrs: {
                                          slot: "reference",
                                          size: "mini",
                                          type: "text",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("通过")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            scope.row.state === 1
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["order_reduce_reject"],
                                        expression: "['order_reduce_reject']",
                                      },
                                    ],
                                    staticClass: "margin-left-5",
                                    attrs: {
                                      slot: "reference",
                                      size: "mini",
                                      type: "text",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handle(scope.row, 0)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("不通过")]
                                )
                              : _vm._e(),
                            scope.row.state === 5
                              ? _c(
                                  "el-popconfirm",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["order_reduce_online"],
                                        expression: "['order_reduce_online']",
                                      },
                                    ],
                                    attrs: { title: "确定上架吗？" },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.handle(scope.row, 3)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "margin-left-5",
                                        attrs: {
                                          slot: "reference",
                                          size: "mini",
                                          type: "text",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("上架")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            [3, 4].includes(scope.row.state)
                              ? _c(
                                  "el-popconfirm",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["order_reduce_offline"],
                                        expression: "['order_reduce_offline']",
                                      },
                                    ],
                                    attrs: { title: "确定下架吗？" },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.handle(scope.row, 2)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "margin-left-5",
                                        attrs: {
                                          slot: "reference",
                                          size: "mini",
                                          type: "text",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("下架")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            [4, 2, 5].includes(scope.row.state)
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["order_reduce_data"],
                                        expression: "['order_reduce_data']",
                                      },
                                    ],
                                    staticClass: "margin-left-5",
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handle(scope.row, "data")
                                      },
                                    },
                                  },
                                  [_vm._v("数据")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("modify", { ref: "modify", on: { onSuccess: _vm.onSuccess } }),
      _c("detail", { ref: "detail" }),
      _c("data-list", { ref: "data" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }